import { ArrowRight, BadgeCheck, ShieldCheck, UserRound } from "lucide-react";
import { AppShot } from "./AppShot";
import { TopoLines } from "./Decor";

const TRUST = [
  { Icon: BadgeCheck, label: "Core tracking stays free" },
  { Icon: UserRound, label: "Start without an account" },
  { Icon: ShieldCheck, label: "Your history stays private" },
];

export const Hero = () => (
  <section id="top" className="relative overflow-hidden">
    <TopoLines className="pointer-events-none absolute -right-24 top-6 hidden text-[#3F8F68] opacity-[0.12] lg:block" />
    <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 pb-20 pt-14 sm:px-8 lg:grid-cols-[1.02fr_0.98fr] lg:pb-28 lg:pt-24">
      <div className="relative z-10">
        <p className="reveal eyebrow inline-flex items-center rounded-lg border border-[#D8D1C5] bg-[#FBFAF5] px-4 py-2 text-[#2F7555]">
          AKTUA Free · Pro optional
        </p>
        <h1
          data-testid="hero-headline"
          className="reveal font-display mt-6 max-w-3xl text-5xl leading-[0.95] text-[#041F1A] sm:text-6xl lg:text-7xl"
          style={{ transitionDelay: "80ms" }}
        >
          Train, eat and progress.
          <span className="mt-2 block text-[#3F8F68]">One clear daily system.</span>
        </h1>
        <p
          className="reveal mt-6 max-w-xl text-base font-medium leading-relaxed text-[#65706A] md:text-lg"
          style={{ transitionDelay: "160ms" }}
        >
          AKTUA connects workout planning, food logging, recipes, hydration and progress so every log has context and the next action stays obvious.
        </p>
        <div className="reveal mt-8 flex flex-wrap items-center gap-4" style={{ transitionDelay: "240ms" }}>
          <a
            href="#get-aktua"
            data-testid="hero-cta-get-aktua"
            className="inline-flex min-h-[48px] items-center gap-2 rounded-xl bg-[#3F8F68] px-7 text-base font-bold text-white transition-colors hover:bg-[#2F7555]"
          >
            Join release updates <ArrowRight size={18} aria-hidden="true" />
          </a>
          <a
            href="#features"
            data-testid="hero-cta-explore-features"
            className="inline-flex min-h-[48px] items-center rounded-xl border border-[#CFC7BA] bg-[#FBFAF5] px-7 text-base font-bold text-[#202622] transition-colors hover:border-[#3F8F68] hover:text-[#2F7555]"
          >
            Explore the app
          </a>
        </div>
        <ul className="reveal mt-10 hidden gap-3 sm:grid sm:grid-cols-3" style={{ transitionDelay: "320ms" }}>
          {TRUST.map(({ Icon, label }) => (
            <li key={label} className="flex items-center gap-2 text-sm font-medium text-[#65706A]">
              <Icon size={17} className="shrink-0 text-[#3F8F68]" aria-hidden="true" />
              {label}
            </li>
          ))}
        </ul>
      </div>

      <div className="reveal hero-product-visual" style={{ transitionDelay: "180ms" }}>
        <div className="hero-glow" aria-hidden="true" />
        <AppShot
          src="/screenshots/aktua-today.webp"
          alt="AKTUA Today screen with calorie and macro progress, weekly training, and quick actions"
          className="hero-shot hero-shot--today"
          eager
        />
        <AppShot
          src="/screenshots/aktua-nutrition.webp"
          alt="AKTUA Nutrition food diary"
          className="hero-shot hero-shot--nutrition"
          eager
        />
      </div>
    </div>
  </section>
);
